import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { TextField, useMediaQuery } from '@material-ui/core';
import { Values } from '../../../../values/Values';
import clsx from 'clsx';
import DialogContent from '@material-ui/core/DialogContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { useTheme } from '@material-ui/styles';
import { TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import { putEmpresa } from '../../../../services/EmpresaService';
import { useStyles } from './ConfiguracoesVisitasStyles';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function ConfiguracoesVisitas(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    empresa,
    setEmpresa,
    setLoading,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
  } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [refreshState, setRefreshState] = useState(new Date());
  const [modoEdicao, setModoEdicao] = useState(false);
  const [erroHoraEmpresa, setErroHoraEmpresa] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  async function salvarEmpresa(event) {
    try {
      event.preventDefault();
      setLoading(true);
      if (!empresa.horaEmpresa) {
        setErroHoraEmpresa(true);
        setLoading(false);
        return;
      }
      let empresaPut = {
        idEmpresa: empresa.idEmpresa,
        horaEmpresa: empresa.horaEmpresa,
      };
      setOpen(false);
      let retorno = await putEmpresa(empresaPut);
      if (retorno.isSuccess) {
        setLoading(false);
        setMessageSnack('Dados atualizados com sucesso.');
        setTypeSnack('success');
        setShowMessageSnack(true);
      }
      else {
        setLoading(false);
        setMessageSnack(retorno.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
        setOpen(true);
      }
      setModoEdicao(false);
      setEmpresa({
        cnpj: '',
        email: '',
        horaEmpresa: undefined,
        idEmpresa: '',
        nomeFantasia: '',
        razaoSocial: '',
      });
    }
    catch (e) {
      setLoading(false);
      setMessageSnack(e.toString());
      setTypeSnack('error');
      setShowMessageSnack(true);
      setOpen(true);
      setModoEdicao(false);
    }
  }

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={!isDesktop}
        TransitionComponent={Transition}
        className={clsx({
            [classes.root]: true
          }
        )}
      >
        <AppBar className={classes.appBar} color={'transparent'} variant={'outlined'}>
          <Toolbar>
            <Typography variant="h6" className={classes.title} >Configurações de visita</Typography>
            <IconButton edge="end" color="primary" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao]: true
                })}
              >
                Aqui você encontra as informações referente a visita de filiados e visitantes. Para editar essas informações
                basta clicar no botão EDITAR e preencher os campos abaixo. Ao finalizar a edição, clique no botão SALVAR
                para manter as alterações.
              </Typography>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <CurrencyTextField
                disabled={!modoEdicao}
                label="Valor da hora do clube"
                helperText='Informe o valor da hora do clube. Esse valor será usado para cálculo na visita.'
                variant="outlined"
                currencySymbol="R$"
                minimumValue="0"
                outputFormat="number"
                decimalCharacter=","
                digitGroupSeparator='.'
                error={erroHoraEmpresa}
                fullWidth
                margin='dense'
                value={empresa.horaEmpresa}
                onChange={(e, value) => {
                  if(!value) {
                    setErroHoraEmpresa(true);
                  }
                  else {
                    setErroHoraEmpresa(false);
                  }
                  empresa.horaEmpresa = value;
                  setEmpresa(empresa);
                  setRefreshState(new Date());
                }}
              />

            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
        >
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={10}
              xs={12}

            >
            </Grid>
            {
              modoEdicao &&
              <Grid
                item
                md={12}
                xs={12}
                className={clsx({
                  [classes.gridBotaoSalvar]: true
                })}
              >
                <Button
                  fullWidth
                  variant={'contained'}
                  color={'primary'}
                  onClick={e => salvarEmpresa(e)}
                >
                  SALVAR
                </Button>
              </Grid>
            }
            {
              !modoEdicao &&
              <Grid
                item
                md={12}
                xs={12}
                className={clsx({
                  [classes.gridBotaoSalvar]: true
                })}
              >
                <Button
                  fullWidth
                  variant={'outlined'}
                  onClick={e => {
                    e.preventDefault();
                    setModoEdicao(true);
                  }}
                >
                  EDITAR
                </Button>
              </Grid>
            }
          </Grid>
        </DialogActions>
      </Dialog>
  );
}

export default ConfiguracoesVisitas;
